import AbstractToggleList from './AbstractToggleList';
import PropTypes from 'prop-types';

export default class RadioList extends AbstractToggleList {
  static propTypes = {
    ...AbstractToggleList.propTypes,
    selectedValue: PropTypes.string
  };

  isValueSelected(value) {
    return this.props.selectedValue === value;
  }
}
